import React from 'react';
import {changeCharmOrientation} from "../lib/actions";
import {connect} from "react-redux";
import {CHARM} from "../../constants";

class OrientationToggle extends React.Component {

    getIcon(option) {
        switch (option) {
            case CHARM.ONELINE:
                return (
                    <svg width="44px" height="26px" viewBox="0 0 44 26">
                        <g id="Product" stroke="none" fill="#FCE2E6" fillRule="evenodd">
                            <path d="M16.625,25 L12.5,25 L11.375,21.75 L5.15,21.75 L3.975,25 L0,25 L7.15,7.5 L10.05,7.5 L16.625,25 Z M8.325,12.95 L6.2,18.825 L10.375,18.825 L8.35,12.95 L8.325,12.95 Z M16,7.5 L20.6,7.5 C22.275,7.5 24.05,7.775 25.35,8.625 C26.7,9.5 27.4,10.875 27.4,12.45 C27.4,13.9 26.65,15.175 25.2,15.825 C26.975,16.425 28.125,17.95 28.125,19.8 C28.125,21.875 26.9,23.5 25,24.3 C23.675,24.85 21.975,25 20.4,25 L16,25 L16,7.5 Z M19.575,17.525 L19.575,22 L20.4,22 C21.45,22 22.55,22 23.3,21.625 C23.925,21.3 24.3,20.775 24.3,19.875 C24.3,18.425 23.35,17.525 21.575,17.525 L19.575,17.525 Z M19.575,10.5 L19.575,14.625 L20.575,14.625 C22.625,14.625 23.825,13.95 23.825,12.575 C23.825,11.775 23.5,11.275 23.075,10.95 C22.4,10.5 21.4,10.5 20.275,10.5 L19.575,10.5 Z M31.275,16.25 C31.275,19.75 33.35,22.175 36.775,22.175 C38.1,22.175 39.425,21.65 40.5,20.725 L42.5,23.325 C40.8,24.625 38.775,25.3 36.625,25.3 C31.375,25.3 27.45,21.6 27.45,16.25 C27.45,11.125 31.625,7.2 36.775,7.2 C38.775,7.2 40.425,7.825 42.15,8.9 L40.425,11.675 C39.375,10.875 38.125,10.325 36.775,10.325 C33.6,10.325 31.275,12.925 31.275,16.25 Z" fillRule="nonzero"></path>
                            <rect x="21.4" y="0" width="2" height="9" rx="1"></rect>
                        </g>
                    </svg>

                );
            case CHARM.TWOLINES:
                return (
                    <svg width="43px" height="43px" viewBox="0 0 43 43">
                        <title>Two line text orientation</title>
                        <g id="Product" stroke="none" fill="#FCE2E6" fillRule="evenodd">
                            <path d="M16.625,25 L12.5,25 L11.375,21.75 L5.15,21.75 L3.975,25 L0,25 L7.15,7.5 L10.05,7.5 L16.625,25 Z M8.325,12.95 L6.2,18.825 L10.375,18.825 L8.35,12.95 L8.325,12.95 Z M16,7.5 L20.6,7.5 C22.275,7.5 24.05,7.775 25.35,8.625 C26.7,9.5 27.4,10.875 27.4,12.45 C27.4,13.9 26.65,15.175 25.2,15.825 C26.975,16.425 28.125,17.95 28.125,19.8 C28.125,21.875 26.9,23.5 25,24.3 C23.675,24.85 21.975,25 20.4,25 L16,25 L16,7.5 Z M19.575,17.525 L19.575,22 L20.4,22 C21.45,22 22.55,22 23.3,21.625 C23.925,21.3 24.3,20.775 24.3,19.875 C24.3,18.425 23.35,17.525 21.575,17.525 L19.575,17.525 Z M19.575,10.5 L19.575,14.625 L20.575,14.625 C22.625,14.625 23.825,13.95 23.825,12.575 C23.825,11.775 23.5,11.275 23.075,10.95 C22.4,10.5 21.4,10.5 20.275,10.5 L19.575,10.5 Z M31.275,16.25 C31.275,19.75 33.35,22.175 36.775,22.175 C38.1,22.175 39.425,21.65 40.5,20.725 L42.5,23.325 C40.8,24.625 38.775,25.3 36.625,25.3 C31.375,25.3 27.45,21.6 27.45,16.25 C27.45,11.125 31.625,7.2 36.775,7.2 C38.775,7.2 40.425,7.825 42.15,8.9 L40.425,11.675 C39.375,10.875 38.125,10.325 36.775,10.325 C33.6,10.325 31.275,12.925 31.275,16.25 Z" fillRule="nonzero"></path>
                            <rect x="21.4" y="0" width="2" height="9" rx="1"></rect>
                            <path d="M7.025,42.25 C11.875,42.25 16.925,39.9 16.925,33.425 C16.925,27.1 11.8,24.75 7.25,24.75 L2,24.75 L2,42.25 L7.025,42.25 Z M6.275,38.9 L6.05,38.9 L6.05,28.1 L6.85,28.1 C10.5,28.1 12.625,30.025 12.625,33.65 C12.625,37.475 10.025,38.9 6.275,38.9 Z M28.325,42.25 L28.325,38.9 L19.875,38.9 L19.875,34.925 L27.325,34.925 L27.325,31.575 L19.875,31.575 L19.875,28.1 L28.325,28.1 L28.325,24.75 L15.825,24.75 L15.825,42.25 L28.325,42.25 Z M33.05,42.25 L33.05,35.35 L40.025,35.35 L40.025,32 L33.05,32 L33.05,28.1 L40.025,28.1 L40.025,24.75 L29,24.75 L29,42.25 L33.05,42.25 Z" fillRule="nonzero"></path>
                        </g>
                    </svg>
                );
            case CHARM.VERTICAL:
                return (
                    <svg width="14px" height="55px" viewBox="0 0 14 55">
                        <title>Vertical text orientation</title>
                        <g id="Product" stroke="none" strokeWidth="1" fill="none">
                            <g fill="#FCE2E6">
                                <path d="M1,23 L5.6,23 C7.275,23 9.05,23.275 10.35,24.125 C11.7,25 12.4,26.375 12.4,27.95 C12.4,29.4 11.65,30.675 10.2,31.325 C11.975,31.925 13.125,33.45 13.125,35.3 C13.125,37.375 11.9,39 10,39.8 C8.675,40.35 6.975,40.5 5.4,40.5 L1,40.5 L1,23 Z M4.575,33.025 L4.575,37.5 L5.4,37.5 C6.45,37.5 7.55,37.5 8.3,37.125 C8.925,36.8 9.3,36.275 9.3,35.375 C9.3,33.925 8.35,33.025 6.575,33.025 L4.575,33.025 Z M4.575,26 L4.575,30.125 L5.575,30.125 C7.625,30.125 8.825,29.45 8.825,28.075 C8.825,27.275 8.5,26.775 8.075,26.45 C7.4,26 6.4,26 5.275,26 L4.575,26 Z"></path>
                                <path d="M3.30398671,47 C3.30398671,50.0939227 5.09634551,52.2375691 8.05481728,52.2375691 C9.19933555,52.2375691 10.3438538,51.7734807 11.2724252,50.9558011 L13,53.2541436 C11.5315615,54.4033149 9.78239203,55 7.92524917,55 C3.39036545,55 0,51.7292818 0,47 C0,42.4696133 3.60631229,39 8.05481728,39 C9.78239203,39 11.2076412,39.5524862 12.6976744,40.5027624 L11.2076412,42.9558011 C10.3006645,42.2486188 9.22093023,41.7624309 8.05481728,41.7624309 C5.31229236,41.7624309 3.30398671,44.0607735 3.30398671,47 Z"></path>
                                <path d="M14,23 L10.5263158,23 L9.57894737,20.2142857 L4.33684211,20.2142857 L3.34736842,23 L0,23 L1.02342252,20.4503897 L6.02105263,8 L8.46315789,8 L14,23 Z M7.03592814,12 L5,17 L9,17 L7.05988024,12 L7.03592814,12 Z"></path>
                                <rect x="6.3" y="0" width="2" height="9" rx="1"></rect>
                            </g>
                        </g>
                    </svg>
                );
        }
    }

    render() {
        let id = 'radio-' + this.props.orientation.description;

        return (
            <>
                <input
                    checked={this.props.isActive}
                    id={id}
                    type="radio"
                    name="Charm Text layout"
                    value={this.props.orientation.description}
                    onChange={() => this.props.onChange(this.props.orientation)}
                />
                <label htmlFor={id} className="product__swatch">
                    {this.getIcon(this.props.orientation)}
                </label>
            </>
        )
    }
}

class OrientationSelector extends React.Component {
    render() {
        return (
            <>
                <div className="product__swatch-container swatch-letter-container">
                    <OrientationToggle isActive={this.props.selectedOrientation === CHARM.ONELINE} orientation={CHARM.ONELINE} onChange={this.props.onChange}/>
                    <OrientationToggle isActive={this.props.selectedOrientation === CHARM.TWOLINES} orientation={CHARM.TWOLINES} onChange={this.props.onChange}/>
                    <OrientationToggle isActive={this.props.selectedOrientation === CHARM.VERTICAL} orientation={CHARM.VERTICAL} onChange={this.props.onChange}/>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        selectedOrientation: state.charmOrientation,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (orientation) => {
            dispatch(changeCharmOrientation(orientation));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OrientationSelector);
